import { render, staticRenderFns } from "./CheckboxBox.vue?vue&type=template&id=61d80014&scoped=true&"
import script from "./CheckboxBox.vue?vue&type=script&lang=js&"
export * from "./CheckboxBox.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxBox.vue?vue&type=style&index=0&id=61d80014&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d80014",
  null
  
)

export default component.exports